import PropTypes from 'prop-types';
import React from 'react';
import i18n from '../../../i18n';

const Flexibility = ({ filters, updateFlexibility }) => {
    if (
        filters.availability &&
        filters.availability.date_range &&
        filters.availability.date_range.from &&
        filters.availability.date_range.to
    ) {
        return (
            <div className="form-group flexibility">
                <label htmlFor="flexibility" className="sr-only">
                    {i18n.t('search:search-flexibility')}
                </label>
                <select
                    name="flexibility"
                    id="flexibility"
                    className="form-control"
                    value={filters.availability.date_range.flexibility || ''}
                    onChange={updateFlexibility}
                >
                    <option value="">{i18n.t('search:search-flexibility')}</option>
                    <option value={1}>+/- {i18n.t('common:duration.day', { count: 1 })}</option>
                    <option value={3}>+/- {i18n.t('common:duration.day', { count: 3 })}</option>
                    <option value={7}>+/- {i18n.t('common:duration.day', { count: 7 })}</option>
                </select>
            </div>
        );
    }

    return null;
};

Flexibility.propTypes = {
    filters: PropTypes.object.isRequired,
    updateFlexibility: PropTypes.func.isRequired
};

export default Flexibility;
